import type * as React from 'react';
import { useTranslation } from 'react-i18next';

import { X } from 'lucide-react';

import { closeModal } from '@/components/modals/modals.utils';
import { ModalBase } from '@/components/modals/modals-base';
import { SunlightSimulationView } from '@/features/track/components/sunlight-simulation-view';

export interface SunlightSimulationModalProps {
  title?: string; // Must be added in the translation file to follow the i18n pattern
  url: string;
}

export const SunlightSimulationModal: React.FC<SunlightSimulationModalProps> = ({ title, url }) => {
  const { t } = useTranslation();
  return (
    <ModalBase className="w-[98vw] max-w-7xl">
      <X
        className="ml-auto cursor-pointer stroke-[4px] text-primary-light"
        onClick={closeModal}
        aria-label={t('close')}
      />
      <SunlightSimulationView title={title} url={url} />
    </ModalBase>
  );
};
